import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { CalendarIcon } from "@/Components/Icons/CalendarIcon";
import {
  updateRecurrenceList,
  updateRepeatObj,
} from "@/reducers/clientcreatejob";

const DateRange = () => {
  const dispatch = useDispatch();
  const {
    jobData,
    repeatObj: { startsOn, endsOn },
  } = useSelector((state) => state.clientCreateJob);
  return (
    <div className="DateRange_Wrapper">
      <div className="grid grid-cols-2 gap-6">
        <div className="customDatePicker flex flex-col gap-3">
          <label className="label" htmlFor="endsOn">
            Starts On
          </label>
          <DatePicker
            format={"DD-MM-YYYY"}
            showToday={false}
            disabledDate={(current) => {
              return current && current < moment().startOf("day");
            }}
            allowClear={false}
            suffixIcon={<CalendarIcon cls="w-[24px] h-[24px] text-primary" />}
            value={startsOn ? dayjs(startsOn, "DD-MM-YYYY") : null}
            onChange={(date, dateString) => {
              let endsOnVal = endsOn;
              if (endsOnVal && dateString) {
                if (
                  dayjs(endsOnVal, "DD-MM-YYYY").isBefore(
                    dayjs(dateString, "DD-MM-YYYY"),
                  )
                ) {
                  dispatch(updateRepeatObj({ endsOn: dateString }));
                }
              }
              dispatch(updateRepeatObj({ startsOn: dateString }));
              dispatch(updateRecurrenceList());
            }}
          />
        </div>
        <div className="customDatePicker flex flex-col gap-3">
          <label className="label" htmlFor="startsOn">
            Ends On
          </label>
          <DatePicker
            format={"DD-MM-YYYY"}
            showToday={false}
            allowClear={false}
            disabledDate={(current) => {
              return (
                current &&
                (current < moment().startOf("day") ||
                  current < moment(startsOn, "DD-MM-YYYY"))
              );
            }}
            suffixIcon={<CalendarIcon cls="w-[24px] h-[24px] text-primary" />}
            value={endsOn ? dayjs(endsOn, "DD-MM-YYYY") : null}
            onChange={(date, dateString) => {
              let startsOnVal = startsOn;
              if (startsOnVal && dateString) {
                if (
                  dayjs(startsOnVal, "DD-MM-YYYY").isAfter(
                    dayjs(dateString, "DD-MM-YYYY"),
                  )
                ) {
                  dispatch(updateRepeatObj({ startsOn: dateString }));
                }
              }
              dispatch(updateRepeatObj({ endsOn: dateString }));
              dispatch(updateRecurrenceList());
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DateRange;
